import { adminUpdate } from "@ttp/goods/models/rtdbObject/adminUpdate";
import { clientUpdate } from "@ttp/goods/models/rtdbObject/clientUpdate";

export const rtdbObject = {
  adminUpdate,
  clientUpdate,
};
